import React from 'react'

const Footer = () => {

    return (
        <div className='bg-[#1E1E1E]' id="footer">
            <h1 className='overflow-hidden news-ticker text-7xl font-bold text-white h-[80px] pt-4'>1234-456-7890 1234-456-7890 1234-456</h1>
            <div className='container mx-auto py-14 px-4'>
                <div className='flex flex-col md:grid grid-rows-1 grid-flow-col gap-4'>
                    <div className='col-span-2 min-h-[150px]'>
                        <p className='text-white max-w-[200px] '>Let Us Help You Get The Justice You Deserve</p>
                    </div>
                    <div>
                        <p className='text-white text-2xl mb-4'>Company</p>
                        <ul className='flex flex-col gap-2 min-h-[150px]'>
                            <li className='text-[#686868]'>

                                <a href='/'>Global Location</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>Missions</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>Carears</a>
                            </li>

                            <li className='text-[#686868]'>
                                <a href='/'>Pricing</a>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className='text-white text-2xl mb-4'>Services</p>
                        <ul className='flex flex-col gap-2  min-h-[150px]'>
                            <li className='text-[#686868]'>
                                <a href='/'>Consultation Now</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>Consumer Insights</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>Financial Services</a>
                            </li>

                            <li className='text-[#686868]'>
                                <a href='/'>Software Research</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p className='text-white text-2xl mb-4'>Features</p>
                        <ul className='flex flex-col gap-2  min-h-[150px]'>
                            <li className='text-[#686868]'>
                                <a href='/'>Become Partner</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>FAQ</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>Why Resolve?</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p className='text-white text-2xl mb-4'>Any Queries</p>
                        <ul className='flex flex-col gap-2  min-h-[150px]'>
                            <li className='text-[#686868]'>
                                <a href='/'>mail@resolve.com</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>+1234567890</a>
                            </li>
                            <li className='text-[#686868]'>
                                <a href='/'>www.resolve.com</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <p className='text-[#686868] mt-8'>Copyright © NY AUTO CASES 2024</p>
            </div>

        </div>
    )
}

export default Footer